import { IFormlyConfig } from "AngularFormly";
import { FormlyTypeSelectMachineController } from "./controller";

export function configSelectMachineFormlyType(
  formlyConfigProvider: IFormlyConfig
) {
  formlyConfigProvider.setType({
    name: "selectMachine",
    controller: FormlyTypeSelectMachineController,
    template: require("!html-loader!./index.html").default,
    wrapper: ["bootstrapLabel", "bootstrapHasError"],
  });
}

configSelectMachineFormlyType.$inject = ["formlyConfigProvider"];
